export const userMenu = [
    {
        lang: 'en',
        menuList: {
            about: 'About us',
            services: 'Services',
            // bim: 'BIM',
            portfolio: 'Portfolio',
            partners: 'Partners',
        },
        languages: {
            en: 'EN',
            ru: 'РУ',
            arm: 'ՀԱՅ',
        }
    },
    {
        lang: 'ru',
        menuList:{
            about: 'О нас',
            services: 'Услуги',
            // bim: 'BIM',
            portfolio: 'Портфолио',
            partners: 'Партнеры',
        },
        languages: {
            en: 'EN',
            ru: 'РУ',
            arm: 'ՀԱՅ',
        },
    },
    {
        lang: 'arm',
        menuList: {
            about: 'Մեր մասին',
            services: 'Ծառայություններ',
            // bim: 'BIM',
            portfolio: 'Պորտֆոլիո',
            partners: 'Գործընկերներ',
        },
        languages: {
            en: 'EN',
            ru: 'РУ',
            arm: 'ՀԱՅ',
        },
    },
];

export const homePage =[
    {
        lang: 'en',
        title: 'About Us',
        vision: 'Functional & smart model ',
        visionText: 'BIM CONSULTING is a team of highly experienced professionals specialized in Building Information Modeling (BIM) technologies. Our skilled specialists are actively involved in projects carried out by leading companies operating in Architecture, Engineering and Construction (AEC) sector in Armenia and abroad.\n' +
            'BIM CONSULTING works also on development and deployment of BIM standards for AEC organizations in Armenia. We provide guidance and support throughout all stages of integration and management processes.\n' +
            'BIM CONSULTING organizes introductory seminars and training courses for construction companies and specialists.',
        mission: 'Our mission',
        missionText: ' We deliver professional BIM service during the entire lifecycle of the project from sustainable design to construction and operational management, thereby increasing the efficiency and productivity of the process.',

    },
    {
        lang: 'ru',
        title: 'О Нас',
        vision: 'Функциональная и  умная модель',
        visionText: 'ООО «БИМ КОНСАЛТИНГ» является экспертом в сфере информационного моделирования объектов капитального строительства. Наши профессионалы принимают активное участие в реализации строительных программ, осуществляемых ведущими проектными организациями на территории Армении и за рубежом.\n' +
            'Компания, в частности, занимается разработкой и внедрением BIM-стандартов для проектных компаний в Республике Армения. «БИМ КОНСАЛТИНГ» также организует курсы по переподготовке специалистов и образовательные семинары.\n',
        mission: 'Наша миссия',
        missionText: 'Мы способствуем повышению эффективности строительных проектов, как в стадии разработки, так и непосредственно в процессе сооружения и эксплуатации объектов.',
    },
    {
        lang: 'arm',
        title: 'Մեր մասին',
        vision: 'Ֆունկցիոնալ և խելացի մոդել',
        visionText: '«ԲԻՄ ԿՈՆՍԱԼԹԻՆԳ»-ը  կառույցների ինֆորմացիոն մոդելավորում  իրականացնող կազմակերպություն է: Մեր թիմի փորձառու անդամները մասնակցում են ինչպես Հայաստանյան, այնպես էլ մի շարք օտարերկրյա կազմակերպությունների կողմից իրականացվող նախագծերում։ \n' +
            '«ԲԻՄ ԿՈՆՍԱԼԹԻՆԳ»-ը իրականացնում է նաև BIM ստանդարտների ինտեգրում նախագծային կազմակերպություններում և մասնագետների վերապատրաստում:',
        mission: 'Մեր առաքելությունն է',
        missionText: 'Նպաստել կառուցապատման ոլորտում իրականացվող նախագծերի արդյունավետության բարձրացմանը՝ ինչպես նախագծման, այնպես էլ շինարարության և շահագործման փուլերում:',
    }
];
export const videoImage = ['', 'team.jpg', 'Pic.jpg'];

export const footer = {
    address: '',
    email: 'info@bimconsulting.am',
    phone: '+37496452004'
};

export const footerData = [
    {
        lang: 'en',
        address: '6/1 Abelyan str., IT Park Business Center, 1st floor, office C-107, Yerevan, Armenia',
        email: 'Email: info@bimconsulting.am',
        phone: 'Phone: +374 96 452004'
    },
    {
        lang: 'ru',
        address: 'Армения, Ереван, Абеляна 6/1, IT Park Бизнес Центр, 1-ый этаж, офис C-107',
        email: 'Эл. почта: info@bimconsulting.am',
        phone: 'Тел.: +374 96 452004'
    },
    {
        lang: 'arm',
        address: 'ք. Երևան, Աբելյան 6/1, IT Park բիզնես կենտրոն, 1-ին հարկ, C-107 սենյակ',
        email: 'էլ. փոստ info@bimconsulting.am',
        phone: 'Հեռ. +374 96 452004'
    },
];


export const servicePage = [
    {
        lang: 'en',
        title: 'Services',
        offer: 'Building close professional contacts with our customers, we use best world practices and BIM experience to process their projects and establish an innovative working atmosphere. Created environment strengthens professional collaboration by enhancing work efficiency and productivity of the BIM workflow.\n' +
            'In today\'s high-tech digital world, BIM CONSULTING will be your reliable partner in the process of integration of BIM technologies.\n',
        informationText: 'BUILDING <b>INFORMATION MODELING</b>',
        informationList: [
            'Development of building information model of a facility, based on an existing project design or sketches',
            'Generation of a 3D model of the building for energy efficiency evaluation using Autodesk Revit and IES VE software'
        ],
        integrationText: '<b>DEVELOPMENT AND INTEGRATION OF BIM STANDARDS</b> IN THE ORGANIZATION',
        integrationList: [
            'Analysis of organization’s field of activity and project design workflow',
            'Development of BIM integration strategy and mechanisms based on the analysis of relative disadvantages of existing workflow, identification of BIM opportunities in the processes and determination of suitable BIM technologies',
            'Development and maintenance of the organization’s BIM standards',
            'Technical support in different phases of the project lifecycle and in the process of training and integration of specialists',
            'Nomination and conduct of a pilot project jointly with the specialists of the organization'

        ],
        turn: ['informationBold', 'information', 'integration', 'integrationBold'],
    },
    {
        lang: 'ru',
        title: 'Сервисы',
        offer: 'Проекты наших заказчиков претворяются в реальность с использованием передового мирового опыта и современных технологий, что создает инновационную среду для развития профессионалов, тем самым повышая эффективность работы и качество сотрудничества всех участников проектно-строительного процесса.\n' +
            'В современном цифровом мире «БИМ КОНСАЛТИНГ» станет вашим надежным партнером по внедрению Технологий Информационного Моделирования (ТИМ/BIM).',
        informationText: '<b>ИНФОРМАЦИОННАЯ МОДЕЛЬ</b> OБЪЕКТОВ СТРОИТЕЛЬСТВА',
        informationList: [
            'Осуществление  информационного моделирования объектов капитального строительства на основе существующей проектной документации или эскизов',
            'Создание 3D моделей для расчета энергоэффективности сооружений с использованием программных пакетов Autodesk Revit и IES VE'
        ],
        integrationText: '<b>РАЗРАБОТКА И ВНЕДРЕНИЕ ТИМ(BIM) СТАНДАРТОВ</b> ДЛЯ ОРГАНИЗАЦИЙ',
        integrationList: [
            'Исследование и анализ сферы деятельности компании, изучение используемых методов организации проектировочных процессов',
            'Разработка стратегии и механизма внедрения BIM-технологий и устранение, выявленных путем сравнительного анализа, недостатков в действующей схеме организации проектировочных процессов',
            'Разработка BIM-стандартов компании',
            'Техническая поддержка и помощь в организации переквалификации и интеграции специалистов компании',
            'Реализация пилотного проекта совместно со специалистами компании'
        ],
        turn: ['informationBold', 'information', 'integrationBold', 'integration'],
    },
    {
        lang: 'arm',
        title: 'Ծառայություններ',
        offer: 'Հիմնվելով լավագույն համաշխարհային փորձի վրա մենք կատարում ենք մեր հաճախորդների պատվերները՝ ստեղծելով նորարական միջավայր ոլորտի մասնագետների համար, բարձրացնելով աշխատանքի արդյունավետությունը և  մասնագետների համագործակցության որակը:\n' +
            'Ժամանակակից թվայնացված աշխարհում մենք խոստանում ենք դառնալ ձեր վստահելի գործընկերը BIM տեխնոլոգիաների ներդրման գործում:',
        informationText: 'ԿԱՌՈՒՅՑՆԵՐԻ <b>ԻՆՖՈՐՄԱՑԻՈՆ ՄՈԴԵԼԱՎՈՐՈՒՄ</b>',
        informationList: [
            'Իրականացնում ենք կառույցների ինֆորմացիոն մոդելավորում  գոյություն\n' +
            'ունեցող նախագծային  փաթեթի կամ էսքիզների հիման վրա',
            'Autodesk Revit և IES VE ծրագրային փաթեթների կիրառմամբ ստեղծում ենք կառույցի եռաչափ մոդել էներգաարդյունավետության հաշվարկի համար',
        ],
        integrationText: 'ԿԱԶՄԱԿԵՐՊՈՒԹՅՈՒՆՆԵՐՈՒՄ <b>BIM ՍՏԱՆԴԱՐՏՆԵՐԻ ՄՇԱԿՈՒՄ ԵՎ ԻՆՏԵԳՐՈՒՄ</b>',
        integrationList: [
            'Կազմակերպության աշխատանքային գործունեության ոլորտի և նախագծային պրոցեսի կազմակերպման հետազոտություն և վերլուծություն',
            'BIM տեխնոլոգիաների ինտեգրման մեխանիզմի և ռազմավարության մշակում՝\n' +
            'ընդգծելով առավելությունները գոյություն ունեցող աշխատանքային\n' +
            'գործընթացի նկատմամբ\n',
            'Կազմակերպության BIM ստանդարտների մշակում',
            'Տեխնիկական աջակցություն մասնագետների վերապատրաստման \n' +
            'և ինտեգրման գրծընթացում',
            'Պիլոտային նախագծի իրականացում կազմակերպության մասնագետների հետ համատեղ',
        ],
        turn: ['information', 'informationBold', 'integration', 'integrationBold'],
    }
];

export const BIMPage = [
    {
        lang: 'en',
        question: 'What is <b>BIM</b> ?',
    },
    {
        lang: 'ru',
        question: 'Что такое <b>BIM</b> ?',
    },
    {
        lang: 'arm',
        question: 'Ի՞նչ է <b>BIM</b> ֊ ը ',
    },
];

export const PartnersPage = [
    {
        lang: 'en',
        title: 'Partners',
    },
    {
        lang: 'ru',
        title: 'Партнеры',
    },
    {
        lang: 'arm',
        title: 'Գործընկերներ',
    },
];

export const PortfolioPage = [
    {
        lang: 'en',
        title: 'Partners',
        page1: 'BUILDING INFORMATION MODELING',
        page2: 'DEVELOPMENT AND INTEGRATION OF BIM STANDARDS IN THE ORGANIZATION',
        client: 'CLIENT\'S FEEDBACK',
    },
    {
        lang: 'ru',
        title: 'Работы',
        page1: 'ИНФОРМАЦИОННАЯ МОДЕЛЬ OБЪЕКТОВ СТРОИТЕЛЬСТВА',
        page2: 'РАЗРАБОТКА И ВНЕДРЕНИЕ ТИМ(BIM) СТАНДАРТОВ ДЛЯ ОРГАНИЗАЦИЙ',
        client: 'ОТЗЫВЫ КЛИЕНТОВ',
    },
    {
        lang: 'arm',
        title: 'Աշխատանքներ',
        page1: 'ԿԱՌՈՒՅՑՆԵՐԻ ԻՆՖՈՐՄԱՑԻՈՆ ՄՈԴԵԼԱՎՈՐՈՒՄ',
        page2: 'ԿԱԶՄԱԿԵՐՊՈՒԹՅՈՒՆՆԵՐՈՒՄ BIM ՍՏԱՆԴԱՐՏՆԵՐԻ ՄՇԱԿՈՒՄ ԵՎ ԻՆՏԵԳՐՈՒՄ',
        client: 'ՀԱՃԱԽՈՐԴՆԵՐԻ ԱՐՁԱԳԱՆՔՆԵՐԸ',
    },
];

export const sliderConfigs = {
    desktop: {
        breakpoint: { max: 3000, min: 1301 },
        items: 3,
        slidesToSlide: 3,
    },
    tablet: {
        breakpoint: { max: 1300, min: 678 },
        items: 2,
        slidesToSlide: 2,
    },
    mobile: {
        breakpoint: { max: 677, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};

export const singleSliderConfigs = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        slidesToSlide: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        slidesToSlide: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};

